import { defineAsyncComponent } from 'vue';
import type { ModularBlockConfig } from '../../../frontend/types';
import { blockBaseTextFields } from './groq';

/**
 * Shared registry entry — apps compose into their own `modularBlocksConfig`.
 *
 * Lazy per the block-loading rule: every block is code-split. The block's HTML
 * is still server-rendered (Suspense resolves async components during SSR), so
 * first paint is unaffected — only hydration waits on this chunk.
 */
export const baseTextBlockConfig = {
  name: 'inner-block-base-text',
  component: defineAsyncComponent(() => import('./CmsBaseTextBlock.vue')),
  innerComponent: defineAsyncComponent(() => import('@pkg/portable-text-editor/web/PortableEditor.vue')),
  fields: blockBaseTextFields,
} satisfies ModularBlockConfig;
